import React from 'react';

import TrashIcon from 'Assets/icons/trash.svg';

export default function ProcurementAttachments(props) {
    const { attachments, onDelete, onDownload, canDelete } = props;

    const downloadAttachment = (e, attachment) => {
        e.preventDefault();
        const url = props.downloadAttachmentUrl.replace('ITEM_ID', props.procurement?.id).replace('ATTACHMENT_ID', attachment.id);

        axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachment.file_name);
            document.body.appendChild(link);
            link.click();
        });
    };

    return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
            {attachments.map((attachment) => (
                <div className="tw-flex tw-flex-row tw-justify-between tw-items-center" key={attachment.id}>
                    <a href="#" onClick={(e) => downloadAttachment(e, attachment)}>
                        {attachment.file_name}
                    </a>
                    {canDelete && (
                        <button type="button" className="button small p-0 h-auto text-danger" onClick={() => onDelete(attachment)} disabled={props.disabled}>
                            <TrashIcon className="tw-w-3 tw-h-3 tw-mr-2" />
                            {$t('Delete')}
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}
